import {
  TFinancePrimary,
  TStatus,
  TPaymentMode,
  TTransactionType,
  TTransactionCategory,
  TTransactionCurrency,
} from '../../apis/finance/finance.interfaces';
import { IFinanceData } from '../../apis/finance/financeMock.interface';
import { mockUserAction } from '../users/userAction';
import { mockDocument } from '../documents/documentMock';

const transactionNames = [
  'Monthly Salary Payment', 'Tuition Fee Collection', 'Library Fee', 'Laboratory Fee',
  'Sports Equipment Purchase', 'Library Books Purchase', 'Computer Lab Maintenance',
  'Infrastructure Maintenance', 'Electricity Bill', 'Water Bill', 'Internet Bill',
  'Security Services', 'Cleaning Services', 'Transportation Fee', 'Hostel Fee',
  'Canteen Revenue', 'Uniform Sales', 'Book Sales', 'Stationery Purchase',
  'Medical Expenses', 'Insurance Premium', 'Staff Training', 'Workshop Expenses',
  'Seminar Fees', 'Conference Expenses', 'Award Ceremony', 'Annual Day Function',
  'Sports Day Expenses', 'Cultural Fest Expenses', 'Science Exhibition', 'Art Exhibition',
  'Music Equipment', 'Dance Studio Setup', 'Gym Equipment', 'Playground Development',
  'Garden Maintenance', 'Building Renovation', 'New Construction', 'Furniture Purchase',
  'Computer Purchase', 'Printer Purchase', 'Projector Purchase', 'Sound System',
  'Lighting Equipment', 'Stage Setup', 'Catering Services', 'Photography Services',
  'Videography Services', 'Printing Services', 'Advertisement', 'Marketing Expenses',
];

const transactionDescriptions = [
  'Monthly salary payment for teaching and non-teaching staff',
  'Tuition fee collection from students for the academic year',
  'Library membership and book rental fees',
  'Laboratory equipment and maintenance charges',
  'Purchase of sports equipment for various games',
  'Purchase of new books for library collection',
  'Maintenance and upgrade of computer laboratory',
  'Infrastructure maintenance and repair work',
  'Monthly electricity bill payment',
  'Monthly water bill payment',
  'Monthly internet and connectivity charges',
  'Security services contract payment',
  'Cleaning and housekeeping services',
  'School bus and transportation fee collection',
  'Hostel accommodation fee collection',
  'Canteen revenue from food sales',
  'School uniform sales revenue',
  'Textbook and reference book sales',
  'Stationery and office supplies purchase',
  'Medical expenses and health services',
  'Insurance premium payment',
  'Staff training and development programs',
  'Workshop and seminar expenses',
  'Seminar registration and participation fees',
  'Conference and meeting expenses',
  'Annual award ceremony expenses',
  'Annual day function celebration costs',
  'Sports day event expenses',
  'Cultural festival organization costs',
  'Science exhibition setup and materials',
  'Art exhibition and display expenses',
  'Music instruments and equipment purchase',
  'Dance studio setup and equipment',
  'Gym equipment and fitness tools',
  'Playground development and equipment',
  'Garden landscaping and maintenance',
  'Building renovation and repair work',
  'New construction project expenses',
  'Furniture and fixtures purchase',
  'Computer and laptop purchase',
  'Printer and scanner purchase',
  'Projector and display equipment',
  'Sound system and audio equipment',
  'Lighting equipment for events',
  'Stage setup and decoration',
  'Catering services for events',
  'Photography services for events',
  'Videography services for documentation',
  'Printing and publication services',
  'Advertisement and promotional expenses',
  'Marketing and outreach activities',
];

function generateFinanceTransaction(index: number): TFinancePrimary {
  const name = transactionNames[index % transactionNames.length];
  const description = transactionDescriptions[index % transactionDescriptions.length];
  
  const baseDate = new Date('2024-01-01');
  const date = new Date(baseDate.getTime() + index * 7 * 24 * 60 * 60 * 1000);
  const dueDate = new Date(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  
  const amount = ((index % 20) + 1) * 5000;
  const type = index % 3 === 0 ? TTransactionType.INCOME : TTransactionType.EXPENSE;
  const category = index % 3 === 0 ? TTransactionCategory.SALARY : TTransactionCategory.EXPENSE;
  const status = index % 4 === 0 ? TStatus.PAID : index % 4 === 1 ? TStatus.PARTIAL : TStatus.UNPAID;
  const paymentMode = [TPaymentMode.BANK, TPaymentMode.ONLINE, TPaymentMode.CASH, TPaymentMode.CHEQUE][index % 4];
  
  const paidAmount = status === TStatus.PAID ? amount : status === TStatus.PARTIAL ? amount * 0.5 : undefined;
  
  const tags = [
    ['salary', 'monthly'],
    ['fees', 'tuition'],
    ['library', 'books'],
    ['maintenance', 'infrastructure'],
    ['equipment', 'purchase'],
    ['utilities', 'bills'],
    ['services', 'contract'],
    ['events', 'celebration'],
  ][index % 8];
  
  return {
    id: String(index + 1),
    name,
    description,
    amount,
    currency: TTransactionCurrency.INR,
    date,
    dueDate,
    tags,
    type,
    category,
    attachments: [mockDocument],
    status,
    paymentMode,
    paidAmount,
    actions: {
      created: mockUserAction,
    },
    academicYear: 2024 + (index % 2),
  };
}

export const mockFinanceData: IFinanceData[] = [];

export const mockFinanceList: TFinancePrimary[] = Array.from({ length: 60 }, (_, i) => generateFinanceTransaction(i));
